import { render } from "./MockTest.vue?vue&type=template&id=256997e2&scoped=true"
import script from "./MockTest.vue?vue&type=script&lang=js"
export * from "./MockTest.vue?vue&type=script&lang=js"

import "./MockTest.vue?vue&type=style&index=0&id=256997e2&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256997e2"]])

export default __exports__